/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function HourglassIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="hourglass"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M4.5 2.5L19.5 2.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M19.5 21.5L4.5 21.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M6 2.5L6 2.648C6 7.465 6.445 8.297 10.453 10.969L12 12L13.547 13.031C17.555 15.703 18 16.535 18 21.352L18 21.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18 2.5L18 2.648C18 7.465 17.555 8.297 13.547 10.969L12 12L10.453 13.031C6.445 15.703 6 16.535 6 21.352L6 21.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
